import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

// Constants
import { FoodOption, Location, PatronOption, SeatingOption } from 'src/types/schema/graphql'

import AmenitiesPill from './AmenitiesPill'
import { parseEnumLabel } from 'src/util/helpers'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'

interface IAmenitiesList {
    location: Location
}

const AmenitiesList: React.FC<IAmenitiesList> = ({ location }) => {
    const patronAmenities: PatronOption[] = location?.traits?.patronOptions
        ? Object.values(location?.traits?.patronOptions)
        : []
    const foodAmenities: FoodOption[] = location?.traits?.foodOptions
        ? Object.values(location?.traits?.foodOptions)
        : []
    const seatingAmenities: SeatingOption[] = location?.traits?.seatingOptions
        ? Object.values(location?.traits?.seatingOptions)
        : []
    const allAmenities = [...patronAmenities, ...foodAmenities, ...seatingAmenities]
    const icons = Object.keys(tailwindConfig.theme.icons)
    const noDataTitle = `Amenities coming soon...`

    const getIconSlug: (value: string) => string = (a: string) => {
        return a === 'WiFi_Available' ? 'HeroIcons.Wifi' : a.replace(/_/g, '')
    }

    return (
        <div className='bdb-location__detail border-b-px border-gray-100 pb-6'>
            <div className='flex items-center'>
                <UI.Heading
                    text='Amenities'
                    size='h6'
                    theme='default'
                    customClasses='text-lg text-gray-500 font-bold'
                />
            </div>
            {allAmenities.length === 0 && <div className='flex'>{noDataTitle}</div>}
            <div className='mt-4 grid grid-cols-2 items-baseline gap-3'>
                {allAmenities.map((a, i) => {
                    const iconExists = icons.includes(getIconSlug(a.toString()))
                    return (
                        <div key={`cell-${a}`} className='flex flex-wrap justify-start gap-2'>
                            {iconExists ? (
                                <AmenitiesPill item={a} />
                            ) : (
                                <UI.Pill
                                    theme='default'
                                    shape='full'
                                    label={parseEnumLabel(a)}
                                    size='md'
                                    customClasses='border-0 bg-white -ml-3'
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default AmenitiesList
